export const ROUTES = {
  root: '/',
  login: '/login',
  dashboard: '/dashboard',
  users: '/users',
  rentals: '/rentals',
  moderation: '/moderation',
  campuses: '/campuses',
  notifications: '/notifications',
  contactMessages: '/contact-messages',
  payments: '/payments',
  settings: '/settings',
} as const;

export type RoutePath = (typeof ROUTES)[keyof typeof ROUTES];
